import colors from '../../../scss/colors.scss';

export const KEY_CODES = {
  ENTER: 13,
  TAB: 9,
  ESCAPE: 27,
  DELETE: 46,
  BACKSPACE: 8,


  LEFT_ARROW: 37,
  UP_ARROW: 38,
  RIGHT_ARROW: 39,
  DOWN_ARROW: 40,
  CTRL_Z: 90,
  KEY_C: 67,
  KEY_X: 88,
  G: 71,
  SPACE: 32,
  SHIFT: 16,
  CTRL: 17,
};

export const DOG_LEG_AVOID_CARD_MARGIN = 10;
export const DOG_LEG_BEND_CURVATURE = 5;

export const DEFAULT_SIBLING_LINK_ANGLE = Math.PI / 2.8;

export const DEFAULTS = {
  MAP_TITLE: 'Untitled Map',
  LINK_COLOR: 'gray4',
  LINK_TYPE: 'solid',
  LINK_WIDTH: 's',
  LINK_CURVATURE: 'arc',
  ANNOTATION_STYLE: 'popout',
  PERSPECTIVE_MEMBERSHIP_STYLE: 'dot',
  CARD_GRAY: '#39424e',
};

export const WIDTHS = {
  IMG_PREVIEW_WIDTH: 1000,
  SIDEBAR_WIDTH: 400,
  NODE_MENU_WIDTH: 200,
  TAG_POPOVER_WIDTH: 225,
  COLOR_PICKER_WIDTH: 100,
  IMAGE_WRAPPER: 310,
};

export const REGION_DEFAULT_SIZE = {
  X: 680,
  Y: 510,
};

export const NODE_TOOLS_SUMMON_DELAY = 150;

export const MENU_OPEN_DELAY = 125;

export const FREE_CARD_LIMIT = 250;

export const FREE_CARD_LIMIT_WARNINGS = [
  150, 200, 225, 240,
];

export const FILE_MAX_SIZE = 25000000;
export const SUBSCRIBER_FILE_MAX_SIZE = 250000000;

export const UNDO_BANNER_TIMEOUT = 3500;
export const UNDO_BANNER_MOUSEOUT_TIMEOUT = 2000;

export const NOTIFICATION_TAG_TIMEOUT = 5000;
export const NOTIFICATION_TAG_MOUSEOUT_TIMEOUT = 2500;


export const STALE_CURSOR_THRESOLD = 5000; // 5 seconds
export const HIDE_CURSOR_THRESOLD = 30000; // 30 seconds

export const TAG_COLORS = [
  colors.kiwi,
  colors.cyan,
  colors.pink,
  colors.yellow,

  colors.green,
  colors.teal,
  colors.orchid,
  colors.orange,

  colors.blue4, //'#0066ff',
  colors.purple,
  colors.fuchsia,
  colors.red, //'#ff5555',
];

export const PERSPECTIVE_COLORS = [
  colors.kiwi,
  colors.cyan,
  colors.pink,
  colors.yellow,

  colors.green,
  colors.teal,
  colors.orchid,
  colors.orange,

  colors.blue4, //'#0066ff',
  colors.purple,
  colors.fuchsia,
  colors.red, //'#ff5555',
];

export const CARD_COLORS = [
  colors.gray4,
  colors.gray5,
  colors.gray6,
  colors.gray7,

  colors.kiwi,
  colors.cyan,
  colors.pink,
  colors.yellow,

  colors.green,
  colors.teal,
  colors.orchid,
  colors.orange,

  colors.blue4,
  colors.purple,
  colors.fuchsia,
  colors.red,
];

export const LINK_COLORS = [
  colors.gray4,
  colors.gray5,
  colors.gray6,
  colors.gray7,

  colors.kiwi,
  colors.cyan,
  colors.pink,
  colors.yellow,

  colors.green,
  colors.teal,
  colors.orchid,
  colors.orange,

  colors.blue4,
  colors.purple,
  colors.fuchsia,
  colors.red,
];

export const LINK_COLORS_MAPPING = {
  [colors.gray1]: 'gray1',
  [colors.gray2]: 'gray2',
  [colors.gray3]: 'gray3',
  [colors.gray4]: 'gray2',
  [colors.gray5]: 'gray3',
  [colors.gray6]: 'gray4',
  [colors.gray7]: 'gray5',
  [colors.kiwi]: 'kiwi',
  [colors.cyan]: 'cyan',
  [colors.pink]: 'pink',
  [colors.yellow]: 'yellow',
  [colors.green]: 'green',
  [colors.teal]: 'teal',
  [colors.orange]: 'orange',
  [colors.orchid]: 'orchid',
  [colors['blue-primary']]: 'blue',
  [colors.purple]: 'purple',
  [colors.fuchsia]: 'fuchsia',
  [colors.red]: 'red',
};

export const COLOR_VAR_TO_HEX_MAPPING = {
  'white': '#ffffff',
  'gray1': colors.gray1,
  'gray2': colors.gray2,
  'gray3': colors.gray3,
  'gray4': colors.gray4,
  'gray5': colors.gray5,
  'gray6': colors.gray6,
  'gray7': colors.gray7,
  'kiwi': colors.kiwi,
  'cyan': colors.cyan,
  'pink': colors.pink,
  'yellow': colors.yellow,
  'green': colors.green,
  'teal': colors.teal,
  'orange': colors.orange,
  'orchid': colors.orchid,
  'blue': colors['blue-primary'],
  'purple': colors.purple,
  'fuchsia': colors.fuchsia,
  'red': colors.red,
};

export const LINK_WIDTHS_MAPPING = {
  'xs': '1.3px',
  's': '2px',
  'm': '4px',
  'l': '6px',
  'xl': '8px',
};

export const BACKGROUND_TO_HEX_MAPPING = {
  'white': colors.white,
  'gray1': colors.gray1,
  'gray2': colors.gray2,
  'gray3': colors.gray3,
  'gray4': colors.gray4,
  'gray5': colors.gray5,
  'gray8': colors.gray8,
};

export const ALLOWED_IMAGE_FILE_TYPES = [
  'image/gif',
  'image/jpeg',
  'image/png',
  'image/x-icon',
];

export const IMAGE_SIZES = {
  'small': 80,
  'medium': 200,
  'large': 400,
};

export const DRAG_NODE_TO_PAN = {
  BUMPER: 10, // margin inside viewport that triggers pan
  MAX_MOVE: 5,
};

export const titleYOffset = 28;
export const titleXOffset = 28;

export const REGION_SNAP_GUTTER = 5;

export const REGION_SNAP_RANGE = 20;

export const FREEHAND_PADDING = 24;

export const STOP_WORDS = [
  'i',
  'me',
  'my',
  'myself',
  'we',
  'our',
  'ours',
  'ourselves',
  'you',
  'your',
  'yours',
  'yourself',
  'yourselves',
  'he',
  'him',
  'his',
  'himself',
  'she',
  'her',
  'hers',
  'herself',
  'it',
  'its',
  'itself',
  'they',
  'them',
  'their',
  'theirs',
  'themselves',
  'what',
  'which',
  'who',
  'whom',
  'this',
  'that',
  'these',
  'those',
  'am',
  'is',
  'are',
  'was',
  'were',
  'be',
  'been',
  'being',
  'have',
  'has',
  'had',
  'having',
  'do',
  'does',
  'did',
  'doing',
  'a',
  'an',
  'the',
  'and',
  'but',
  'if',
  'or',
  'because',
  'as',
  'until',
  'while',
  'of',
  'at',
  'by',
  'for',
  'with',
  'about',
  'against',
  'between',
  'into',
  'through',
  'during',
  'before',
  'after',
  'above',
  'below',
  'to',
  'from',
  'up',
  'down',
  'in',
  'out',
  'on',
  'off',
  'over',
  'under',
  'again',
  'further',
  'then',
  'once',
  'here',
  'there',
  'when',
  'where',
  'why',
  'how',
  'all',
  'any',
  'both',
  'each',
  'few',
  'more',
  'most',
  'other',
  'some',
  'such',
  'no',
  'nor',
  'not',
  'only',
  'own',
  'same',
  'so',
  'than',
  'too',
  'very',
  's',
  't',
  'can',
  'will',
  'just',
  'don',
  'should',
  'now',
];

export const COLLABORATION_QUOTES = [
  { quote: 'Share your work with others!' },
  // { author: 'Jim Stovall', quote: 'When we all help one another, everybody wins.' },
  // { author: 'Oliver Wendell Holmes', quote: 'Many ideas grow better when transplanted into another mind than the one where they sprang up.' },
  // { author: 'Napolean Hill', quote: 'It is literally true that you can succeed best and quickest by helping others to succeed.' },
  // { author: 'Helen Keller', quote: 'Alone we can do so little; together we can do so much.' },
  // { author: 'Vince Lombardi', quote: 'Individual commitment to a group effort -- that is what makes a team work, a company work, a society work, a civilization work.' },
  // { author: 'Steve Jobs', quote: 'Great things in business are never done by one person; they’re done by a team of people.' },
  // { author: 'Reid Hoffman', quote: 'No matter how brilliant your mind or strategy, if you’re playing a solo game, you’ll always lose out to a team.' },
  // { author: 'Henry Ford', quote: 'Coming together is a beginning, staying together is progress, and working together is success.' },
  // { author: 'Simon Mainwaring', quote: 'Effectively, change is almost impossible without industry-wide collaboration, cooperation, and consensus.' },
  // { author: 'Michael Jordan', quote: 'Talent wins games, but teamwork and intelligence win championships.' },
];



// WEBPACK FOOTER //
// ./starling/src/lib/constants.js